import React, { FC } from 'react'
import { Link, LinkProps } from 'react-router-dom'
import cx from 'classnames'
import styles from './ButtonLink.module.scss'

export const VARIANTS = ['primary', 'accent', 'secondary', 'danger', 'outline'] as const
type Variant = typeof VARIANTS[number]

export const SIZES = ['small', 'default'] as const
type Size = typeof SIZES[number]

type ButtonLinkProps = LinkProps & {
  to: string
  full?: boolean
  variant?: Variant
  size?: Size
}

export const ButtonLink: FC<ButtonLinkProps> = ({
  full,
  className = '',
  variant = 'primary',
  size = 'default',
  ...other
}) => {
  const classes = cx({
    [styles.buttonLink]: true,
    [styles.full]: full,
    [styles[variant]]: variant,
    [styles[size]]: size,
    [className]: className,
  })

  return <Link className={classes} {...other} />
}

ButtonLink.displayName = 'ButtonLink'
